const API_TOKEN = 'i0mHVRscU3GlYD7r5t8j'


export default API_TOKEN